<div class="modal-header main-modal-header">
    <h4 class="modal-title wrap-text-in">Users Belong to this {{clientOrBuLabel}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <p>
                There are users reporting to this user that belong to this {{clientOrBuLabel}}.
            </p>
        </div>
        <app-subordinates-in-bu [userId]="modalData.userId" [buId]="modalData.buId"></app-subordinates-in-bu>
        <div class="col-xs-12 text-right">
            <div class="clearfix">
                <button type="button" class="btn btn-primary" (click)="closeModal()">OK</button>
            </div>
        </div>
    </div>
</div>
